query allCompetitions(
  $first: Int,
  $offset: Int,
  $filter: CompetitionFilter,
  ) {
  competitions: allCompetitions(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      competitionMappings: competitionMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
          regionMapping {
            extRef
          }
        }
      }
      competitionId
      competitionName
      source
      region {
        regionName
      }
    }
    totalCount
  }
}
